/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FeedbackInputs */

const en_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Feedback`)
};

const de_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback senden`)
};

const fr_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer un commentaire`)
};

const es_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar comentarios`)
};

const it_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia feedback`)
};

const nl_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback sturen`)
};

const pl_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyslij opinie`)
};

const fi_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä palautetta`)
};

const da_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send feedback`)
};

const sv_nav_feedback = /** @type {(inputs: Nav_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka feedback`)
};

/**
* | output |
* | --- |
* | "Send Feedback" |
*
* @param {Nav_FeedbackInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_feedback = /** @type {((inputs?: Nav_FeedbackInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FeedbackInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_feedback(inputs)
	if (locale === "fr") return fr_nav_feedback(inputs)
	if (locale === "es") return es_nav_feedback(inputs)
	if (locale === "it") return it_nav_feedback(inputs)
	if (locale === "nl") return nl_nav_feedback(inputs)
	if (locale === "pl") return pl_nav_feedback(inputs)
	if (locale === "fi") return fi_nav_feedback(inputs)
	if (locale === "da") return da_nav_feedback(inputs)
	if (locale === "sv") return sv_nav_feedback(inputs)
	return en_nav_feedback(inputs)
});